import { JtechAxios } from 'src/plugins/axios'
import { JtechMessage } from 'src/plugins/system.messages'

export const OrganizationalStructureRepository = {
  USERS_SELF: 'users/self/',
  findOrganizationalStructures: async function () {
    try {
      const dataResponse = await JtechAxios.request().get(
        this.USERS_SELF + 'organizational-structures'
      )
      return Array.from(dataResponse.data)
    } catch (ex) {
    }
  },

  findProfile: async function () {
    try {
      const dataResponse = await JtechAxios.request().get(
        this.USERS_SELF + 'profile'
      )
      return dataResponse.data
    } catch (ex) {
    }
  },

  activateOrganizationalStructureById: async function (id) {
    try {
      await JtechAxios.request().put(
        this.USERS_SELF + 'organizational-structures/' + id + '/activate'
      )
      JtechMessage.success(JtechMessage.getText('ORGANIZATIONAL_STRUCTURE_CHANGE_SUCCESS'))
    } catch (ex) {
      JtechMessage.error(JtechMessage.getText('ORGANIZATIONAL_STRUCTURE_CHANGE_ERROR'))
    }
  }
}
